export default "__VITE_ASSET__CxfqA5Qq__"